import React, { FC } from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

export const BlockProtocolIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      {...props}
      width="71"
      height="108"
      viewBox="0 0 71 108"
      fill="none"
    >
      <path
        d="M39.9512 21.6H21.5122V12.3429C21.5122 9.06933 20.2171 5.92989 17.9117 3.61515C15.6064 1.30042 12.4797 0 9.2195 0H0V95.6572C0 98.9307 1.29511 102.07 3.60043 104.385C5.90575 106.7 9.03245 108 12.2927 108H21.5122V86.4H39.9512C48.2921 86.0833 56.1864 82.5336 61.976 76.4964C67.7655 70.4592 71 62.4042 71 54.0231C71 45.6421 67.7655 37.5872 61.976 31.5499C56.1864 25.5127 48.2921 21.963 39.9512 21.6463V21.6ZM39.9512 64.8H21.5122V43.2H39.9512C46.0975 43.2 50.3231 48.0831 50.3231 54C50.3231 59.9169 46.0975 64.7769 39.9512 64.7769V64.8Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
